import _ from 'lodash'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { Dictionary } from '../../utils/types'

import { FiltersMetaRow } from './FiltersMetaRow'

export type FiltersMetaRowWrapperProps = {
  filters: Dictionary<any>
  filterKeysToTranslationsMapper: Dictionary<string>
  dateFilterKeys: string[]
  onClose?: (filterKey: string) => void
  translationGroups?: string[]
}

export const FiltersMetaRowWrapper = ({
  filters,
  filterKeysToTranslationsMapper,
  dateFilterKeys,
  onClose,
  translationGroups = ['form']
}: FiltersMetaRowWrapperProps) => {
  const { t } = useTranslation(translationGroups)

  return (
    <FiltersMetaRow
      filters={_.map(_.keys(filters), filterKey => ({
        key: filterKey,
        label: filterKeysToTranslationsMapper[filterKey] ? t(filterKeysToTranslationsMapper[filterKey]) : filterKey,
        value: _.includes(dateFilterKeys, filterKey)
          ? moment(filters[filterKey]).format('DD/MM/YYYY')
          : _.has(filters[filterKey], 'label')
            ? _.get(filters[filterKey], 'label')
            : filters[filterKey]
      }))}
      onClose={onClose}
    />
  )
}
